// import React, { useState } from "react";
// import Container from "react-bootstrap/Container";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from "react-bootstrap/NavDropdown";
// import "./Navbar2.css";
// import Logo from "./logo.png";
// import { Link } from "react-router-dom";

// function Navbar2() {
//   const [expanded, setExpanded] = useState(false);

//   const toggleNav = () => {
//     setExpanded(!expanded);
//   };

//   return (
//     <Navbar
//       id="nav"
//       expand="lg"
//       expanded={expanded}
//       className="bg-body-white p-0 nav2-container"
//     >
//       <Container>
//         <Navbar.Brand>
//           <Link to="/">
//             <img src={Logo} height="90px" className="Logo h-5" alt="Logo" />
//           </Link>
//         </Navbar.Brand>
//         <Navbar.Toggle onClick={toggleNav} aria-controls="basic-navbar-nav" />
//         <Navbar.Collapse id="basic-navbar-nav">
//           <Nav className="me-auto margin-start">
//             <p className="m-2">
//               <Link className="fs-5 text-black" onClick={toggleNav} to="/">
//                 Home
//               </Link>
//             </p>
//             <p className="m-2">
//               <Link
//                 className="fs-5 text-black"
//                 onClick={toggleNav}
//                 to="/services"
//               >
//                 Services
//               </Link>
//             </p>
//             <NavDropdown
//               title="Products"
//               id="basic-nav-dropdown"
//               className="nav-drop-down"
//             >
//               <NavDropdown.Item
//                 onClick={toggleNav}
//                 href="https://bizpetro.com"
//                 target="blank"
//               >
//                 Bizpetro
//               </NavDropdown.Item>
//               <NavDropdown.Item onClick={toggleNav} href="/weighbridgeAutomation">
//                 Weighbridge Automation
//               </NavDropdown.Item>
//               <NavDropdown.Item onClick={toggleNav} href="/crushermanagement">
//                 AI Based Crusher Management System
//               </NavDropdown.Item>
//               <NavDropdown.Item onClick={toggleNav} href="/realEstateErp">
//                 Real Estate ERP
//               </NavDropdown.Item>
//               <NavDropdown.Item onClick={toggleNav} href="/sugarErp">
//                 Sugar ERP
//               </NavDropdown.Item>
//               <NavDropdown.Item onClick={toggleNav} href="/solventExtractionErp">
//                 Solvent Extraction ERP
//               </NavDropdown.Item>
//             </NavDropdown>

          
//             <NavDropdown
//               title="About Us"
//               id="basic-nav-dropdown"
//               className="nav-drop-down"
//             >
//               <a
//                 className="d-block ps-3 text-black py-1 droupdown-link"
//                 onClick={toggleNav}
//                 href="/about"
//               >
//                 Company
//               </a>
//               <a
//                 className="d-block ps-3 text-black py-1 droupdown-link"
//                 onClick={toggleNav}
//                 href="/team"
//               >
//                 Team
//               </a>

//               <a
//                 className="d-block ps-3 text-black py-1 droupdown-link"
//                 onClick={toggleNav}
//                 href="/work"
//               >
//                 How we work
//               </a>
//               <a
//                 className="d-block ps-3 text-black py-1 droupdown-link"
//                 onClick={toggleNav}
//                 href="/contact"
//               >
//                 Contact
//               </a>
//             </NavDropdown>

//             <p className="m-2">
//               <Link
//                 onClick={toggleNav}
//                 className="fs-5 text-black"
//                 to="/career"
//               >
//                 Career
//               </Link>
//             </p>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }

// export default Navbar2;


import React, { useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Navbar2.css";
import Logo from "./logo.png";

function Navbar2() {
  const [expanded, setExpanded] = useState(false);

  const toggleNav = () => setExpanded(!expanded);

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      className="nav2-container"
      sticky="top"
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand as={Link} to="/">
          <img src={Logo} className="Logo" alt="Logo" />
        </Navbar.Brand>

        <Navbar.Toggle onClick={toggleNav} />

        <Navbar.Collapse>
          <Nav className="ms-auto align-items-center gap-3">

            <Nav.Link as={Link} to="/" onClick={toggleNav} className="nav-link-custom">
              Home
            </Nav.Link>

            <Nav.Link as={Link} to="/services" onClick={toggleNav} className="nav-link-custom">
              Services
            </Nav.Link>

            <NavDropdown title="Products" className="nav-drop-down" align="end" >
              <NavDropdown.Item href="https://bizpetro.com" target="_blank">
                Bizpetro
              </NavDropdown.Item>
              <NavDropdown.Item href="/weighbridgeAutomation">
                Weighbridge Automation
              </NavDropdown.Item>
              <NavDropdown.Item href="/crushermanagement">
                AI Crusher System
              </NavDropdown.Item>
              <NavDropdown.Item href="/realEstateErp">
                Real Estate ERP
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="About Us" className="nav-drop-down" align="end">
              <NavDropdown.Item href="/about">Company</NavDropdown.Item>
              <NavDropdown.Item href="/team">Team</NavDropdown.Item>
              <NavDropdown.Item href="/work">How We Work</NavDropdown.Item>
              <NavDropdown.Item href="/contact">Contact</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/career" onClick={toggleNav} className="nav-link-custom">
              Career
            </Nav.Link>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbar2;